import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SEB_TEST_DATA } from '../../data/sebTestData';
import './MegaTest.css';

const Question = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const questionId = parseInt(id);
    const question = SEB_TEST_DATA.questions.find(q => q.id === questionId);

    // Default to 'ko' if language is not 'en' (or add more logic if needed)
    const currentLang = i18n.language === 'en' ? 'en' : 'ko';

    const [answers, setAnswers] = useState(() => {
        try {
            const saved = localStorage.getItem('megaTestAnswers');
            return saved ? JSON.parse(saved) : {};
        } catch (e) {
            console.error("Failed to parse megaTestAnswers", e);
            return {};
        }
    });

    useEffect(() => {
        if (!question) {
            navigate('/mega-test');
        }
    }, [question, navigate]);

    if (!question) return null;

    const short = (text, max = 95) => {
        const v = String(text || '').replace(/\s+/g, ' ').trim();
        if (v.length <= max) return v;
        const cut = v.slice(0, max);
        const lastDot = Math.max(cut.lastIndexOf('.'), cut.lastIndexOf('!'), cut.lastIndexOf('?'));
        const lastKorDot = cut.lastIndexOf('다.');
        const sentenceEnd = Math.max(lastDot, lastKorDot + 1);
        if (sentenceEnd >= Math.floor(max * 0.5)) {
            return cut.slice(0, sentenceEnd + 1).trim();
        }
        const last = cut.lastIndexOf(' ');
        const compact = (last > max * 0.6 ? cut.slice(0, last) : cut).trim();
        return /[.!?]$/.test(compact) ? compact : `${compact}.`;
    };

    const progress = (questionId / SEB_TEST_DATA.questions.length) * 100;

    const handleAnswer = (index) => {
        const newAnswers = { ...answers, [questionId]: index };
        setAnswers(newAnswers);
        localStorage.setItem('megaTestAnswers', JSON.stringify(newAnswers));

        if (questionId < SEB_TEST_DATA.questions.length) {
            navigate(`/mega-test/q/${questionId + 1}`);
        } else {
            navigate('/mega-test/loading');
        }
    };

    return (
        <div className="question-container">
            <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${progress}%` }}></div>
            </div>

            <div className="question-card">
                <span className="q-number">Question {questionId} of {SEB_TEST_DATA.questions.length}</span>
                <h2 className="question-text">{short(question.q[currentLang], 110)}</h2>

                <div className="options-grid">
                    {question.a[currentLang].map((option, index) => (
                        <button
                            key={index}
                            className="option-btn"
                            onClick={() => handleAnswer(index)}
                        >
                            {short(option, 95)}
                        </button>
                    ))}
                </div>
            </div>


        </div>
    );
};

export default Question;
